"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeClusterGroupTabIndex = void 0;
function removeClusterGroupTabIndex(container) {
    const observe = () => {
        const mapContainer = container.querySelector('.c-openstreetmap__map');
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((addedNode) => {
                        var _a, _b;
                        if (addedNode instanceof HTMLElement &&
                            (((_a = addedNode.classList) === null || _a === void 0 ? void 0 : _a.contains('c-openstreetmap__icon')) ||
                                ((_b = addedNode.classList) === null || _b === void 0 ? void 0 : _b.contains('marker-cluster')))) {
                            addedNode.setAttribute('tabindex', '-1');
                        }
                    });
                }
            });
        });
        if (!mapContainer)
            return;
        observer.observe(mapContainer, { childList: true, subtree: true });
    };
    observe();
}
exports.removeClusterGroupTabIndex = removeClusterGroupTabIndex;
